import PropTypes from 'prop-types';
import { useRef } from 'react';
import { twMerge } from 'tailwind-merge';

import Sidebar from 'components/Sidebar';
import AppBanner from 'components/Sidebar/AppBanner';
import FeaturedOffersList from 'components/Sidebar/FeaturedOffersList';
import ForumSidebarDescription from 'components/Sidebar/ForumSidebarDescription';
import RelevantSubcategories from 'components/Sidebar/RelevantSubcategories';

const ForumThreadSidebar = ({ className, featuredOffers = [], ...rest }) => {
  const featuredOffersListRef = useRef(null);
  const forumSidebarDescriptionRef = useRef(null);

  return (
    <Sidebar
      className={twMerge('col-span-4 hidden gap-y-4 xl:flex', className)}
      refsToBeIgnoredBeforeFixing={[
        forumSidebarDescriptionRef,
        featuredOffersListRef,
      ]}
      {...rest}
    >
      <ForumSidebarDescription ref={forumSidebarDescriptionRef} />
      <FeaturedOffersList
        ref={featuredOffersListRef}
        featuredOffers={featuredOffers}
      />
      <RelevantSubcategories />
      <AppBanner />
    </Sidebar>
  );
};

ForumThreadSidebar.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  featuredOffers: PropTypes.arrayOf(
    PropTypes.shape({
      offerId: PropTypes.number.isRequired,
      offerTitle: PropTypes.string.isRequired,
      offerPrice: PropTypes.number.isRequired,
      offerOldPrice: PropTypes.number,
      offerPriceType: PropTypes.string.isRequired,
      offerPhoto: PropTypes.string.isRequired,
      offerSlug: PropTypes.string.isRequired,
    })
  ),
};

export default ForumThreadSidebar;
